import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicLanding from "@/pages/PublicLanding";
import VerificationResult from "@/pages/VerificationResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import IssueCertificate from "@/pages/IssueCertificate";
import BulkImport from "@/pages/BulkImport";
import VerificationLogs from "@/pages/VerificationLogs";
import RevokedList from "@/pages/RevokedList";
import TrainingPrograms from "@/pages/TrainingPrograms";
import Transcripts from "@/pages/Transcripts";
import Students from "@/pages/Students";
import BulkOperations from "@/pages/BulkOperations";
import AdminLayout from "@/components/AdminLayout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="label-eyebrow">Authenticating…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<PublicLanding />} />
            <Route path="/verify" element={<PublicLanding />} />
            <Route path="/verify/:certNumber" element={<VerificationResult />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="students" element={<Students />} />
              <Route path="issue" element={<IssueCertificate />} />
              <Route path="bulk-ops" element={<BulkOperations />} />
              <Route path="programs" element={<TrainingPrograms />} />
              <Route path="transcripts" element={<Transcripts />} />
              <Route path="bulk" element={<BulkImport />} />
              <Route path="logs" element={<VerificationLogs />} />
              <Route path="revoked" element={<RevokedList />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
